import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import testBackground from "../assets/stacked-waves-haikei.svg";
import axiosInstance from "../common/services/axiosInstance";
import { useCharactersContext } from "../hooks/Context";

interface Level {
  classId: number;
  name: string;
  examinationId: number;
}

const Levels = () => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width:820px)");
  const { studentLevel } = useCharactersContext();
  const navigate = useNavigate();

  const { moduleId } = useParams();
  const [levels, setLevels] = useState<Level[]>([]);

  useEffect(() => {
    // axios
    //   .get(`${BASE_URL}/api/master/class/list`, {
    //     headers: {
    //       authorization: "Bearer " + localStorage.getItem("authorization"),
    //     },
    //   })
    axiosInstance
      .get("/api/master/class/list", {
        params: {
          examinationId: moduleId,
        },
      })
      .then((response: any) => {
        setLevels(response.data.responseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [moduleId]);

  return (
    <div
      style={{
        // background: "linear-gradient(to top, #D9F6FF, #FFFFFF)",
        minHeight: "100vh",
        marginTop: "0",
        backgroundImage: `url(${testBackground})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: isMobile ? "15.5%" : isTablet ? "8%" : "10vh",
          marginBottom: "5vh",
          marginLeft: "auto",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: isMobile || isTablet ? "5vh" : "7vh",
            flexBasis: "100%",
            flexShrink: 2,
            textAlign: "left",
            fontWeight: "bold",
          }}
        >
          Levels
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginLeft: isMobile ? "5%" : "2.5%",
          marginTop: "1.5vh",
        }}
      >
        <IconButton
          sx={{
            borderRadius: "50%",
            boxShadow: "10",
            // height: "3vh",
            "&.MuiIconButton-root": {
              backgroundColor: "primary.main",
              color: "white !important",
            },
          }}
          onClick={() => {
            navigate(-1);
          }}
          size="small"
        >
          <ArrowBackIcon />
        </IconButton>
      </Box>
      <Grid
        container
        justifyContent="center"
        spacing={2}
        xs={12}
        style={{ height: "80vh", marginTop: "1vh" }}
      >
        {levels
          .slice()
          .sort((a, b) => a.classId - b.classId)
          .map((level) => {
            const isAdmin = localStorage.getItem("userType") === "ADMIN";
            const isActiveLevel = isAdmin || level.name === studentLevel;

            return (
              <Grid item key={level.classId} xs={12} sm={6}>
                <Card
                  variant="outlined"
                  sx={{
                    borderRadius: "10px",
                    marginLeft: isMobile ? "7%" : "7%",
                    // marginRight: isMobile ? "3%" : "1%",
                    width: isMobile ? "auto" : "auto",
                    height: isMobile ? "auto" : "auto",
                    // boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                    cursor: isActiveLevel ? "pointer" : "not-allowed",
                    // marginBottom: "1vh",
                    // background:
                    //   "linear-gradient(263deg, rgba(36,92,166,1) 47%, rgba(217,246,255,1) 100%)",
                    backgroundColor: "primary.main",
                    color: "white",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    opacity: isActiveLevel ? 1 : 0.55,
                    position: "relative",
                    pointerEvents: isActiveLevel ? "auto" : "none",
                    filter: isActiveLevel ? "none" : "grayscale(40%)",
                  }}
                  onClick={() => {
                    navigate(
                      `/modules/${moduleId}/levels/${level.classId}/lessons`
                    );
                  }}
                >
                  {/* Disabled sheen overlay */}
                  {!isActiveLevel && (
                    <Box
                      sx={{
                        position: "absolute",
                        inset: 0,
                        background:
                          "linear-gradient(135deg, rgba(255,255,255,0.25), rgba(255,255,255,0))",
                        zIndex: 1,
                        borderRadius: "10px",
                      }}
                    />
                  )}

                  <CardContent sx={{ position: "relative", zIndex: 2 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "900",
                        textAlign: "center",
                        fontSize: isMobile || isTablet ? "2.5vh" : "4vh",
                      }}
                    >
                      {level.name}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
};
export default Levels;
